export default __webpack_public_path__ + "static/media/full4.c43e3795.jpg";